import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcGlobalOverview = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "m14.53 7.47 2 2-1.061 1.06-2-2 1.06-1.06Zm-6 6 2 2-1.061 1.06-2-2 1.06-1.06Zm2-4.94-2 2-1.061-1.06 2-2 1.06 1.06Zm6 6-2 2-1.061-1.06 2-2 1.06 1.06Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 4.475 10.475 6 12 7.525 13.525 6 12 4.475Zm.707-1.768a1 1 0 0 0-1.414 0L8.707 5.293a1 1 0 0 0 0 1.414l2.586 2.586a1 1 0 0 0 1.414 0l2.586-2.586a1 1 0 0 0 0-1.414l-2.586-2.586ZM12 16.475 10.475 18 12 19.525 13.525 18 12 16.475Zm.707-1.768a1 1 0 0 0-1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l2.586 2.586a1 1 0 0 0 1.414 0l2.586-2.586a1 1 0 0 0 0-1.414l-2.586-2.586Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M5.293 8.707a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1-1.414 0l-2.586-2.586a1 1 0 0 1 0-1.414l2.586-2.586Zm12 0a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1-1.414 0l-2.586-2.586a1 1 0 0 1 0-1.414l2.586-2.586Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcGlobalOverview");

export { IcGlobalOverview };
//# sourceMappingURL=ic-global-overview.js.map
